import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle2, MessageSquare, Send } from "lucide-react";
import { API, getAuthHeader } from "@/App";
import { Label } from "@/components/ui/label";

/* Where each due occurrence is posted in Team Chat: a team channel or one person (DM). */
export const ChatTargetSelect = ({ value, onChange, users }) => {
  const teams = [...new Set(users.map((u) => u.team).filter(Boolean))].sort();
  return (
    <div className="col-span-2">
      <Label>Post in Team Chat to</Label>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} className="mt-1 h-9 w-full rounded-md border px-2 text-sm" data-testid="recurring-chat-target">
        <option value="">My team's channel</option>
        <optgroup label="Team channel">{teams.map((t) => <option key={t} value={`team:${t}`}>#{t}</option>)}</optgroup>
        <optgroup label="Person (direct message)">{users.map((u) => <option key={u.id} value={`user:${u.id}`}>{u.name} ({u.team})</option>)}</optgroup>
      </select>
      <p className="mt-1 text-[11px] text-slate-500">On each due day it appears there as a task card (and in My pending). Tick it done in chat or here — both close together.</p>
    </div>
  );
};

const post = (path) => axios.post(`${API}${path}`, {}, { headers: getAuthHeader() });

/* On the recurring task card: today's chat copy — status, Mark done, or post it now. */
export const ChatOccurrence = ({ task, st, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const run = async (path, msg) => {
    setBusy(true);
    try { await post(path); toast.success(msg); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); } finally { setBusy(false); }
  };
  const today = new Date(Date.now() + 5.5 * 3600000).toISOString().slice(0, 10);
  const posted = st && st.date === today;
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2 text-xs" data-testid={`recurring-chat-${task.id}`}>
      <MessageSquare className="h-3.5 w-3.5 text-indigo-500" />
      {st ? <span className={`rounded-md border px-2 py-0.5 font-semibold ${st.done ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-amber-200 bg-amber-50 text-amber-800"}`} data-testid={`recurring-chat-status-${task.id}`}>
        {st.date === today ? "Today" : st.date}: {st.done ? `Done${st.done_by ? ` by ${st.done_by}` : ""}` : "Open in chat"}</span>
        : <span className="text-slate-400">Not posted to chat yet</span>}
      {st && !st.done && <button type="button" disabled={busy} onClick={() => run(`/recurring-chat/${task.id}/done`, "Marked done — closed in chat too")}
        className="inline-flex items-center gap-1 rounded-md border border-emerald-300 bg-emerald-50 px-2 py-0.5 font-semibold text-emerald-800 hover:bg-emerald-100 disabled:opacity-50" data-testid={`recurring-done-${task.id}`}>
        <CheckCircle2 className="h-3.5 w-3.5" />Mark done</button>}
      {!posted && task.status === "active" && <button type="button" disabled={busy} onClick={() => run(`/recurring-chat/${task.id}/post-now`, "Posted to Team Chat")}
        className="inline-flex items-center gap-1 rounded-md border px-2 py-0.5 font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50" data-testid={`recurring-post-now-${task.id}`}>
        <Send className="h-3.5 w-3.5" />Post to chat now</button>}
    </div>
  );
};
